module.exports = __webpack_public_path__ + "img/pr-7.1f1ee888.png";